<!--214 is for GoAppActivitiesComponent-->
<ion-grid no-padding [ngClass]="(from == 214)?'go-app-activities-filter-menu':'filter-menu-right-modal-home-screen'"
  [ngClass]="(isRightPaneNavActive)?'preview-active':'preview-inactive'">
  <ion-row no-padding>
    <ion-col class="select-list-left-pane" [ngClass]="!readOnly?'searchActive':'searchInactive'" no-padding>
      <ion-header>
        <ind-header-left  [viewData]="filterMenuHeaderLeftModel"
                          [hideFilterButton]="true"
                          [searchDisabled]="readOnly"
                          [(searchText)]="searchInput"
                          (onControlClick)="onPageTitleControlClick($event)"
                          (onSearchInit)="onSearchInit($event)"
                          (onSearchInput)="searchText($event)"
                          (onSearchClear)="onCancel($event)"
                          [searchHidden]="searchHidden"
                          >
        </ind-header-left>
      </ion-header>
      <ion-content class="no-scroll" [scrollPadding]="true" [ngClass]="{'vectorimageleft' : categories.length === 0}">
          <ion-list *ngIf="viewData" [ngClass]="{'margin-bottom-above-fab': footerService.shouldApplyBottomMargin(true)}">
            <ind-section-header [viewData]="searching ? searchedFilterMenuSectionHeader : filterMenuSectionHeader"
              (onControlClick)="onSectionHeaderControlClick($event)"></ind-section-header>
            <div class="search-bar-container" *ngIf="showSearchBar">
              <ion-searchbar autoFocusSearchbar [(ngModel)]="searchInput" (ionInput)="searchText($event)" class="home-screen-searchbar">
              </ion-searchbar>
            </div>
              <ng-container *ngIf="!searching">
                  <ion-item-group>
                      <p *ngIf="isSaveFilterEnabled && categories && categories.length == 0 && (!savedFilters || savedFilters && savedFilters.childItems && savedFilters.childItems.length == 0)" justify-content-center class="no-data-message">
                          {{ 'NO' | translate}} {{((viewData)?viewData.title:'' )| lowercase}}
                      </p>
                      <p *ngIf="!isSaveFilterEnabled && categories && categories.length == 0" justify-content-center class="no-data-message">
                          {{ 'NO' | translate}} {{((viewData)?viewData.title:'' )| lowercase}}
                      </p>
                  </ion-item-group>
                  <ion-item-group>
                    <omni-accordion id="saved-filter-toggle" *ngIf="isSaveFilterEnabled && savedFilters && savedFilters.childItems && savedFilters.childItems.length > 0" [viewData]="savedFilters" (onToggleSingleItem)="selectSavedCategories(savedFilters, $event)" (onSelectDefault)="selectDefultOption(savedFilters,$event)"></omni-accordion>
                  </ion-item-group>
                  <ion-item-group *ngIf="isDisplayDateField">
                    <ion-row>
                      <ion-col size="6"><ind-datetime-form *ngIf="startDateField" [viewData]="startDateField"></ind-datetime-form></ion-col>
                      <ion-col size="6"><ind-datetime-form *ngIf="endDateField" [viewData]="endDateField"></ind-datetime-form></ion-col>
                    </ion-row>
                  </ion-item-group>
                  <ng-container *ngFor="let item of categories; trackBy: trackById">
                    <!-- Parent category accordion header (e.g. "Ladders") — collapsible, same visual level as other filters -->
                    <div class="parent-category-header" *ngIf="item.isParentCategory" (click)="item.isExpanded = !item.isExpanded">
                      <span class="parent-category-label">{{ item.primaryText }}</span>
                      <ion-icon [name]="item.isExpanded ? 'remove-outline' : 'add-outline'" class="parent-expand-icon"></ion-icon>
                    </div>
                    <!-- Regular accordion: hidden when its parent category is collapsed -->
                    <div [class.sub-category-indent]="item.parentId && !item.isParentCategory"
                         *ngIf="!item.isParentCategory && (!item.parentId || isParentExpanded(item.parentId))">
                      <omni-accordion id="category-filter-toggle"
                        [viewData]="item"
                        (onToggleSingleItem)="toggleCategoryValue(item, $event)"
                        (onToggleItem)="toggleCategoryValue(item, $event)"
                        (onToggleItemClick)="toggleOptionClick(item,$event)"
                        (onLoadMoreOptions)="loadMoreOptions(item,$event)"
                        (onSelectDefault)="selectDefultOption($event)"
                        (onRangeChange)="onRangeFilterChange(item, $event)">
                      </omni-accordion>
                    </div>
                    <ion-row *ngIf="item.id == 'myActivitiesByContact' && item.isExpanded">
                      <ion-col size="6"><ind-datetime-form *ngIf="startDateField && isSelectedMyActivity" [viewData]="startDateField"></ind-datetime-form></ion-col>
                      <ion-col size="6"><ind-datetime-form *ngIf="endDateField && isSelectedMyActivity" [viewData]="endDateField"></ind-datetime-form></ion-col>
                    </ion-row>
                    <div *ngIf="item.id == 'myActivitiesByContact' && item.isExpanded" class="separationLine"></div>
                  </ng-container>
              </ng-container>
              <ng-container *ngIf="searching">
                <ion-item-group *ngIf="isDisplayDateField">
                  <ion-row>
                    <ion-col size="6"><ind-datetime-form *ngIf="startDateField" [viewData]="startDateField"></ind-datetime-form></ion-col>
                    <ion-col size="6"><ind-datetime-form *ngIf="endDateField" [viewData]="endDateField"></ind-datetime-form></ion-col>
                  </ion-row>
                </ion-item-group>
                <ng-container *ngFor="let item of searchedCategories; trackBy: trackById">
                  <omni-accordion [viewData]="item" (onToggleItem)="toggleCategoryValue(item, $event)" (onToggleItemClick)="toggleOptionClick(item,$event)" (onLoadMoreOptions)="loadMoreOptions(item,$event)" (onRangeChange)="onRangeFilterChange(item, $event)" ></omni-accordion>
                  <ion-row *ngIf="item.id == 'myActivitiesByContact' && item.isExpanded">
                    <ion-col size="6"><ind-datetime-form *ngIf="startDateField && isSelectedMyActivity" [viewData]="startDateField"></ind-datetime-form></ion-col>
                    <ion-col size="6"><ind-datetime-form *ngIf="endDateField && isSelectedMyActivity" [viewData]="endDateField"></ind-datetime-form></ion-col>
                  </ion-row>
                  <div *ngIf="item.id == 'myActivitiesByContact' && item.isExpanded" class="separationLine"></div>
                </ng-container>
            </ng-container>
          </ion-list>
          <ind-no-search-result *ngIf="searching && searchInput && categories.length === 0" [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
      </ion-content>
      <div *ngIf="saveFooterEnabled" class="filter-actions">
        <ion-buttons slot="end">
          <ion-button *ngIf="authService.user.buConfigs['indskr_multicalendar']" class="btn" [disabled]="!saveButtonEnabled" (click)="saveAdvancedSearch()"> {{'SAVE_FILTER' | translate}}</ion-button>
          <ion-button class="btn" [disabled]="_isDisabledClearFilter()"
            (click)="onSectionHeaderControlClick('clear-filter')">{{'CLEAR_FILTER' | translate}}</ion-button>
          <ion-button class="btn apply" [disabled]="noChanges" (click)="goBack(true)">{{'APPLY' | translate}}</ion-button>
        </ion-buttons>
      </div>
      <ng-container *ngIf="!saveFooterEnabled">
        <footer-toolbar *ngIf="isSaveFilterFooterVisible" [footerView]="'masterView'" [selectedView]="'indFilterMenu'"
          (buttonClicked)="footerButtonClicked($event)"></footer-toolbar>
        <footer-toolbar *ngIf="!isSaveFilterEnabled" [footerView]="'masterView'"
          [selectedView]="'select-list'"></footer-toolbar>
      </ng-container>
    </ion-col>
    <ion-col class="select-list-right-pane" no-padding>
      <ng-container *ngIf="isRightPaneNavActive && optionsList">
        <ion-header>
          <ind-page-title [viewData]='{id:"filter-options-list",title: selectedCategory.primaryText}'
            (onControlClick)='onCloseRightPane()'></ind-page-title>
        </ion-header>
        <ion-content>
          <div class="show-more-container">
          <ion-searchbar autoFocusSearchbar #rightPaneSearchbar (ionInput)="searchOptions($event)" showCancelButton="never" placeholder="{{'SEARCH' | translate}}"></ion-searchbar>
          <virtual-list [source$]="displayOptionList$" (update)="viewPortItems = $event" [height]="'off'" [visibleChildren]="12" [bufferAmount]="3" [childHeight]="44" [hidden]="isOptionsSearching && filteredOptionsList.length === 0 ? true : undefined">
            <ion-item *ngFor="let item of viewPortItems; trackBy: trackById" (click)="selectItem(item)">
              <ng-container *ngIf="item.category !== 'Teamusers'">
                <ion-checkbox labelPlacement="end" justify="start" [checked]="item.isChecked">{{item.label}}</ion-checkbox>
                <!-- <ion-checkbox [checked]="item.isChecked"></ion-checkbox>
                <ion-label> {{item.label}} </ion-label> -->
              </ng-container>
              <ng-container *ngIf="item.category === 'Teamusers' && !device.isOffline">
                <omni-accordion-item [item]="item" [viewData]="viewData" [depth]="0 + 1">
                </omni-accordion-item>
              </ng-container>
            </ion-item>
          </virtual-list >
          <!-- <ion-list class="dropdown-options-list">
            <ion-item *ngFor="let item of displayOptionsList" (click)="selectItem(item)">
              <ng-container *ngIf="item.category !== 'Teamusers'">
                <ion-checkbox [checked]="item.isChecked"></ion-checkbox>
                <ion-label> {{item.label}} </ion-label>
              </ng-container>
              <ng-container *ngIf="item.category === 'Teamusers' && !device.isOffline">
                <omni-accordion-item [item]="item" [viewData]="viewData" [depth]="0 + 1">
                </omni-accordion-item>
              </ng-container>
            </ion-item>
          </ion-list>
          <ion-infinite-scroll (ionInfinite)="doInfinite($event.detail,$event)" threshold="30%">
            <ion-infinite-scroll-content></ion-infinite-scroll-content>
          </ion-infinite-scroll> -->
          <ind-no-search-result *ngIf="isOptionsSearching && filteredOptionsList.length === 0" [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
          </div>
        </ion-content>
        <!-- <ion-footer> -->
        <footer-toolbar *ngIf="footerService.shouldShowFooter$ | async" [footerView]="'detailView'" [selectedView]="'opportunityList'">
        </footer-toolbar>
      </ng-container>
      <nothing-selected-view *ngIf="!isRightPaneNavActive" [textToDisplay]="''" [notShowText]="true" style="background-color: aqua;" [deviceString]="device.deviceFlags.ios ? 'ios' : 'android'"></nothing-selected-view>
    </ion-col>
  </ion-row>
</ion-grid>
